import { CanActivateFn } from '@angular/router';
import { environment } from '../environments/environment';

export const tokenGuard: CanActivateFn = (route, state) => {
  const token = route.queryParamMap.get('token') || localStorage.getItem('access_token');

  function isTokenExpired(token: string): boolean {
    try {
      const payload = JSON.parse(atob(token.split('.')[1]));
      if (!payload.exp) return true;
      const now = Math.floor(Date.now() / 1000);
      return payload.exp < now;
    } catch (e) {
      return true;
    }
  }

  if (token) {
    if (route.queryParamMap.get('token')) {
      localStorage.setItem('access_token', token);
      window.location.replace('/titulos');
    }
    if (isTokenExpired(token)) {
      console.log("linea 24 token guard")
      localStorage.removeItem('access_token');
      window.location.href = environment.portalUrl + 'auth/iniciar-sesion';
      return false;
    }
    return true;
  }
  window.location.href = environment.portalUrl + 'auth/iniciar-sesion';
  return false;
};
